module.exports = __webpack_public_path__ + "media/svg-new/icon-voltar-5800feee.svg";